import Image from 'next/image';
import React from 'react';

const IntegrationsTechAiStrategy = () => {
    return (
        <div className="section-py !pt-0 !pb-0 dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-4 dark:text-white" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Integrations & Tech Stack
                        </h2>
                        <p className='mb-0' data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            These integrations serve as the critical backbone that seamlessly connects AI capabilities with your existing systems, ensuring scalable, adaptable, and efficient deployment.
                        </p>
                    </div>
                </div>
                 <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 mb-[30px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-orchestration-framework.svg"
                                width={36}
                                height={36}
                                alt="Assessment & Analytics Frameworks"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Assessment & Analytics Frameworks</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            CMMI-AI, Google PAIR, Microsoft AI Maturity, Gartner/McKinsey frameworks, and custom scorecards to assess AI readiness and capability gaps.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-mcp-protocol.svg" width={36} height={36} alt="Strategic Planning Tools" />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Strategic Planning Tools</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Business Model Canvas, Value Chain Analysis, Technology Radar, Wardley Mapping, OKR frameworks, and Balanced Scorecards to align AI initiatives with business objectives & priorities.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-llm-integration.svg"
                                width={36}
                                height={36}
                                alt="ROI & Financial Modeling"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">ROI & Financial Modeling</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Excel and Google Sheets financial models, Tableau or Power BI for scenario analysis, Monte Carlo simulations, and NPV/IRR calculators to build solid business cases and demonstrate AI investment returns.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 mb-[30px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-vector-database.svg"
                                width={36}
                                height={36}
                                alt="Technology Evaluation Platforms"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Technology Evaluation Platforms</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Gartner Magic Quadrant, Forrester Wave reports, G2 vendor comparisons, GitHub benchmarks, and cloud provider cost calculators to evaluate AI platforms, tools & conduct build-versus-buy analyses.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-rpa-tools.svg"
                                width={36}
                                height={36}
                                alt="Data Assessment Tools"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Data Assessment Tools</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Data quality profiling instruments, metadata management platforms, data lineage trackers, schema analyzers & sample data analysis scripts to assess data readiness
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-minitoring-&-observation.svg"
                                width={36}
                                height={36}
                                alt="Collaboration & Workshop Tools"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Collaboration & Workshop Tools</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Miro, Mural, and Figma for interactive workshops, Notion or Confluence for documentation, and Slack or Microsoft Teams for streamlined stakeholder communication in strategy sessions.
                        </p>
                    </div>
                </div>
                 <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3">
                    
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-low-code-platforms.svg" width={36} height={36} alt="Proof-of-Concept Frameworks" />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Proof-of-Concept Frameworks</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           upyter notebooks, Streamlit, and Gradio within cloud sandbox environments (AWS, Azure, GCP) to enable fast, cost-effective validation of AI concepts before full-scale investment.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-integration-tools.svg"
                                width={36}
                                height={36}
                                alt="Governance & Compliance"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Governance & Compliance</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           IEEE and EU guidelines, regulatory compliance checklists including GDPR and CCPA, and structured risk assessment matrices to ensure legal and ethical alignment.
                        </p>
                    </div>
                </div>
               
            </div>
        </div>
    );
};

export default IntegrationsTechAiStrategy;
